var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinear({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.308 3.03c-1.62.246-2.29.43-3.253.893-.318.153-.797.423-1.064.599-.57.377-1.53 1.201-1.698 1.457l-.118.18 6.335 6.33c3.484 3.482 6.368 6.331 6.409 6.331.041 0 .312-.253.602-.563 2.637-2.816 3.225-6.847 1.5-10.282-1.15-2.287-3.32-4.03-5.81-4.664-.95-.243-2.3-.373-2.903-.281zM4.14 7.565c-.09.155-.23.42-.311.59l-.148.307 5.922 5.921c5.304 5.302 5.94 5.917 6.082 5.883.173-.043.949-.461.996-.538.016-.026-2.763-2.836-6.175-6.246l-6.203-6.2-.163.283zm-.97 2.505c-.106.335-.17.753-.17 1.105v.407l4.701 4.697 4.702 4.697.338.021c.348.022 1.271-.105 1.271-.175 0-.021-2.433-2.47-5.406-5.442-3.455-3.453-5.418-5.37-5.436-5.31zm-.014 3.94c.061.38.382 1.317.651 1.9.785 1.697 2.406 3.348 4.155 4.23.495.25 1.401.571 1.99.705l.416.094-3.603-3.602c-1.982-1.98-3.615-3.601-3.628-3.601-.014 0-.005.123.019.273z",
    fill: "#5D69E5"
  })));
}

export default SvgLinear;